import { useState } from 'react'
import { cn } from '@/lib/utils'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  containerClassName?: string
  aspectRatio?: string
  objectFit?: 'cover' | 'contain'
  blurHash?: string
}

export function Image({
  src,
  alt = '',
  containerClassName,
  aspectRatio,
  objectFit = 'cover',
  className,
  loading = 'lazy',
  blurHash,
  ...props
}: ImageProps) {
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  if (error || !src) {
    return (
      <div
        className={cn(
          'flex items-center justify-center bg-stone text-xs font-semibold tracking-[0.15em] text-carbon',
          containerClassName
        )}
        style={aspectRatio ? { aspectRatio } : undefined}
      >
        LITTLE SKY
      </div>
    )
  }

  return (
    <div
      className={cn('relative overflow-hidden bg-stone', containerClassName)}
      style={aspectRatio ? { aspectRatio } : undefined}
    >
      {blurHash && !loaded && (
        <div
          className="absolute inset-0 bg-stone blur-xl"
          aria-hidden="true"
        />
      )}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        className={cn(
          'h-full w-full transition-opacity duration-500 ease-out-expo',
          objectFit === 'cover' ? 'object-cover' : 'object-contain',
          loaded ? 'opacity-100' : 'opacity-0',
          className
        )}
        {...props}
      />
    </div>
  )
}
